//* Libraries imports
import { Check } from "lucide-react";

type PaymentSuccessModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onFinalize?: () => void;
  title?: string;
  message?: string;
};

export function PaymentSuccessModal({
  isOpen,
  onClose,
  onFinalize,
  title = "APROVADO!",
  message = "Pagamento realizado com sucesso.",
}: PaymentSuccessModalProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4 animate-in fade-in duration-200">
      <div className="bg-white w-full max-w-xs rounded-2xl p-6 flex flex-col items-center gap-6 shadow-xl">
        <div className="size-24 rounded-full bg-blue-100 flex items-center justify-center">
          <div className="bg-claroprimaria-01 rounded-full p-2">
            <Check size={40} className="text-white" strokeWidth={3} />
          </div>
        </div>

        <div className="flex flex-col items-center gap-1">
          <h2 className="text-lg font-bold text-clarotexto-201">{title}</h2>
          <p className="text-sm text-gray-500 text-center">{message}</p>
        </div>

        <button
          onClick={onFinalize || onClose}
          className="w-full h-11 bg-claroprimaria-01 text-white rounded-xl font-semibold hover:bg-claroprimaria-01/90 transition-colors"
        >
          Finalizar
        </button>
      </div>
    </div>
  );
}
